import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Form } from 'components/atoms/form';
import { TertiaryButton } from 'components/atoms/tertiary-button';

export const FormItem = styled(Form.Item)`
  padding-bottom: var(--layout-01);
  margin-bottom: var(--layout-01);
`;

export const FooterContainer = styled.div`
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const Footer = ({ onCancel, children }) => {
  return (
    <FooterContainer>
      <TertiaryButton onClick={onCancel}>
        <FormattedMessage id="cancel" />
      </TertiaryButton>
      {children}
    </FooterContainer>
  );
};
